export default "__VITE_ASSET__zRUnh7XX__"